import React from 'react';
import DescontoFlexService from '../../../../lib/api/descontoFlex/descontoFlexService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class DescontoFlex extends React.Component<{},{}> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    baixarExcelDescontoFlex()
    {
       return DescontoFlexService.obterExcel()
    }

    enviarParametrosEventGrid()
    {
        return DescontoFlexService.enviarDescontoFlexAoEventGrid();
    }

    render()
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelDescontoFlex}
                enviarExcelParametros={DescontoFlexService.salvarExcelDescontoFlex}
                deletarExcelParametros={DescontoFlexService.deletarExcelDescontoFlex}
                nomeDoArquivo='% Desconto Flex'
            ></TemplateParametro>
        );
    }
}

export default DescontoFlex;